import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import TableFunction from "../../../../../components/table/TableFunction";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {SimpleSearchWithId} from "../../../../../reduxToolkit/Search/SearchApi";
import {DOCUMENT_MODEL} from "../../Model/Models";
import {calculateHeight, DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../../../Apis/functions";
import FileCardList from "../../SubComponents/FileCardList";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Main component for managing contractor access rights
const DocumentationHistoryTabApp = ({
    id,
    historyModel,
    historyRef
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [data, setData] = useState({ content: [], totalElements:0});

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model: historyModel, userId: id});
        dispatch(SimpleSearchWithId({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success === true) {
                setData({content: data?.content?.map((d) => DOCUMENT_MODEL.toSet(d)), totalElements: data?.totalElements});
            }
        });
    }

    const { rowsPerPage, pagination } = TableFunction({
        labelRowsPerPage: 'documentation_per_page',
        data,
        hasContainer: true,
        fixedPagination: false,
        getData//New
    });

    useEffect(() => {
        if(data?.content?.length > 0) getCards();
    }, [data?.content]);

    const getCards = () => {
        const rows = [];
        let last = null;

        data?.content?.forEach(item => {
            const date = getDateFormat(item.createdAt, false);

            const header = last !== date
                ? (
                    <div key={`header-${date}`}>
                        <p className='fs-14px font-color-general-950 text-ellipsis-1-row ibl-font-w-600 mb-3 mt-3'>
                            {t('uploaded')}: {getDateFormat(item.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </p>
                    </div>
                )
                : null;

            last = date;

            rows.push(
                <div key={item.id}>
                    {header}
                    <FileCardList item={item} />
                </div>
            );
        });
        return rows;
    };

    useEffect(() => {
        calculateHeight({elementRef: historyRef, bottom: 70})
    }, [historyRef, data?.content]);

    // Return necessary values and state setters to be used by components consuming this logic
    return {
        t,
        data,
        getCards,
        pagination
    };
}

// Export the component for use in other parts of the application
export default DocumentationHistoryTabApp;
